import IconTabBar from './IconTabBar';

export default IconTabBar;
